import { client } from './client'
import { getCsrf, getCookie } from './authentication'
import { CustomError } from '../CustomError'
import { CSRF_TOKEN_NAME } from '@/constants'

export const createVideo = async (
  documentVersionId: string,
  values: {
    name: string
  },
) => {
  await getCsrf()
  const resp = await client.POST(
    '/api/v1/projects/{document_version_id}/videos',
    {
      headers: {
        'X-CSRFToken': getCookie(CSRF_TOKEN_NAME),
      },
      params: {
        path: {
          document_version_id: documentVersionId,
        },
      },
      body: values,
    },
  )

  if (resp.error || !resp.response.ok) {
    const message = 'Failed to create video'
    throw new CustomError(resp, message)
  }

  return resp.data
}

export const listVideos = async (documentVersionId: string) => {
  const resp = await client.GET(
    '/api/v1/projects/{document_version_id}/videos',
    {
      params: {
        path: {
          document_version_id: documentVersionId,
        },
      },
    },
  )

  if (resp.error || !resp.response.ok) {
    const message = 'Failed to list videos'
    throw new CustomError(resp, message)
  }

  return resp.data
}

export const getVideo = async (videoId: string) => {
  const resp = await client.GET('/api/v1/projects/videos/{video_id}', {
    params: {
      path: {
        video_id: videoId,
      },
    },
  })

  if (resp.error || !resp.response.ok) {
    const message = 'Failed to get video'
    throw new CustomError(resp, message)
  }

  return resp.data
}

export const deleteVideo = async (videoId: string) => {
  await getCsrf()
  const resp = await client.DELETE('/api/v1/projects/videos/{video_id}', {
    headers: {
      'X-CSRFToken': getCookie(CSRF_TOKEN_NAME),
    },
    params: {
      path: {
        video_id: videoId,
      },
    },
    parseAs: 'text',
  })

  if (resp.error || !resp.response.ok) {
    const message = 'Failed to delete video'
    throw new CustomError(resp, message)
  }

  return true
}
